import React, { useEffect, useState } from "react";
// @material-ui/core
import { makeStyles } from "@material-ui/core/styles";
import {
  Card,
  CardContent,
  CardHeader,
  Grid,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Button,
  Box,
  Chip,
  Paper,
  Divider,
  CircularProgress,
  Avatar,
  Container
} from "@material-ui/core";
// @material-ui/icons
import {
  Person,
  Phone,
  TrendingUp,
  Assessment,
  DateRange,
  Refresh,
  PhoneCallback,
  PhoneMissed,
  CheckCircle,
  Cancel,
  Schedule,
  Visibility,
  Assignment,
  PhoneDisabled,
  AccountCircle,
  Email,
  SupervisorAccount
} from "@material-ui/icons";

import { fetchEmplyeeDetails } from "views/Apis/AfterLogin";
import { fetchTodayEmployeeStats } from "views/Apis/AfterLogin";
import { fetchDateRangeEmployeeStats } from "views/Apis/AfterLogin";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
    backgroundColor: '#f8f9fa',
    minHeight: '100vh',
  },
  welcomeCard: {
    marginBottom: theme.spacing(3),
    padding: theme.spacing(3),
    borderRadius: 12,
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    color: 'white',
    boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
  },
  filterCard: {
    marginBottom: theme.spacing(3),
    padding: theme.spacing(3),
    borderRadius: 12,
    boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
  },
  filterGrid: {
    marginTop: theme.spacing(2),
  },
  statCard: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    borderRadius: 12,
    transition: 'all 0.3s ease-in-out',
    border: 'none',
    boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
    '&:hover': {
      transform: 'translateY(-4px)',
      boxShadow: '0 8px 30px rgba(0,0,0,0.12)',
    },
  },
  statContent: {
    textAlign: 'center',
    padding: theme.spacing(3),
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    minHeight: 160,
  },
  statIcon: {
    fontSize: 48,
    marginBottom: theme.spacing(2),
  },
  statValue: {
    fontSize: '2.5rem',
    fontWeight: 700,
    marginBottom: theme.spacing(1),
    lineHeight: 1,
  },
  statLabel: {
    color: theme.palette.text.secondary,
    fontSize: '0.9rem',
    fontWeight: 500,
    marginBottom: theme.spacing(1),
  },
  breakdownCard: {
    marginTop: theme.spacing(3),
    borderRadius: 12,
    boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
  },
  breakdownHeader: {
    paddingBottom: theme.spacing(1),
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  breakdownContent: {
    padding: theme.spacing(3),
  },
  breakdownItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(2, 0),
    borderBottom: `1px solid ${theme.palette.grey[100]}`,
    '&:last-child': {
      borderBottom: 'none',
    },
  },
  breakdownLabel: {
    fontSize: '0.95rem',
    fontWeight: 500,
    color: theme.palette.text.primary,
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: 300,
    backgroundColor: 'white',
    borderRadius: 12,
    boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
  },
  employeeInfo: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0),
  },
  employeeAvatar: {
    marginRight: theme.spacing(3),
    backgroundColor: 'rgba(255,255,255,0.2)',
    width: 80,
    height: 80,
    fontSize: '2rem',
  },
  employeeDetails: {
    flex: 1,
  },
  employeeName: {
    fontSize: '2rem',
    fontWeight: 700,
    marginBottom: theme.spacing(1),
    color: 'white',
  },
  employeeContact: {
    color: 'rgba(255,255,255,0.9)',
    fontSize: '1rem',
    marginBottom: theme.spacing(0.5),
    display: 'flex',
    alignItems: 'center',
  },
  contactIcon: {
    marginRight: theme.spacing(1),
    fontSize: '1.2rem',
  },
  percentageChip: {
    fontWeight: 600,
    fontSize: '0.8rem',
    marginTop: theme.spacing(1),
  },
  sectionTitle: {
    fontSize: '1.1rem',
    fontWeight: 600,
    marginBottom: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.text.primary,
  },
  sectionIcon: {
    marginRight: theme.spacing(1),
    fontSize: '1.3rem',
  },
  additionalStatsGrid: {
    marginTop: theme.spacing(4),
  },
  additionalStatCard: {
    height: '100%',
    borderRadius: 12,
    transition: 'all 0.3s ease-in-out',
    boxShadow: '0 2px 10px rgba(0,0,0,0.06)',
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
    },
  },
  additionalStatContent: {
    textAlign: 'center',
    padding: theme.spacing(2),
    minHeight: 120,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  additionalStatIcon: {
    fontSize: 32,
    marginBottom: theme.spacing(1),
  },
  additionalStatValue: {
    fontSize: '1.8rem',
    fontWeight: 600,
    marginBottom: theme.spacing(0.5),
  },
  additionalStatLabel: {
    fontSize: '0.8rem',
    color: theme.palette.text.secondary,
    fontWeight: 500,
  },
  emptyState: {
    padding: theme.spacing(6),
    textAlign: 'center',
    backgroundColor: 'white',
    borderRadius: 12,
    boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
    marginTop: theme.spacing(3),
  },
  emptyStateIcon: {
    fontSize: 80,
    color: theme.palette.grey[300],
    marginBottom: theme.spacing(2),
  },
  formControl: {
    minWidth: '100%',
  },
  applyButton: {
    borderRadius: 8,
    fontWeight: 600,
    textTransform: 'none',
    boxShadow: 'none',
    '&:hover': {
      boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
    },
  },
  leadAssignmentGrid: {
    marginTop: theme.spacing(3),
  },
  leadAssignmentCard: {
    height: '100%',
    borderRadius: 12,
    transition: 'all 0.3s ease-in-out',
    boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
    border: '2px solid transparent',
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: '0 6px 25px rgba(0,0,0,0.12)',
      borderColor: theme.palette.primary.light,
    },
  },
  welcomeText: {
    fontSize: '1.1rem',
    marginBottom: theme.spacing(2),
    opacity: 0.95,
  },
  onlineStatus: {
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(2),
  },
  statusDot: {
    width: 12,
    height: 12,
    borderRadius: '50%',
    backgroundColor: '#4caf50',
    marginRight: theme.spacing(1),
    animation: '$pulse 2s infinite',
  },
  '@keyframes pulse': {
    '0%': {
      transform: 'scale(0.95)',
      boxShadow: '0 0 0 0 rgba(76, 175, 80, 0.7)',
    },
    '70%': {
      transform: 'scale(1)',
      boxShadow: '0 0 0 10px rgba(76, 175, 80, 0)',
    },
    '100%': {
      transform: 'scale(0.95)',
      boxShadow: '0 0 0 0 rgba(76, 175, 80, 0)',
    },
  },
  performanceCard: {
    padding: theme.spacing(2),
    borderRadius: 12,
    background: 'rgba(255,255,255,0.1)',
    marginTop: theme.spacing(2),
  },
  performanceTitle: {
    fontSize: '1rem',
    fontWeight: 600,
    marginBottom: theme.spacing(1),
    color: 'white',
  },
  performanceGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: theme.spacing(2),
  },
  performanceItem: {
    textAlign: 'center',
  },
  performanceValue: {
    fontSize: '1.5rem',
    fontWeight: 700,
    color: 'white',
  },
  performanceLabel: {
    fontSize: '0.8rem',
    color: 'rgba(255,255,255,0.8)',
  },
}));

export default function EmployeeDashboard() {
  const classes = useStyles();
  const [employeeData, setEmployeeData] = useState(null);
  const [analyticsData, setAnalyticsData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);

  // Date filters
  const [viewType, setViewType] = useState('today');
  const [startDate, setStartDate] = useState(new Date().toISOString().split('T')[0]);
  const [endDate, setEndDate] = useState(new Date().toISOString().split('T')[0]);

  // Get userId from sessionStorage
  const userId = sessionStorage.getItem("userId");

  // Fetch employee details and initial analytics on component mount
  useEffect(() => {
    const fetchInitialData = async () => {
      if (!userId) {
        console.error("No userId found in sessionStorage");
        setInitialLoading(false);
        return;
      }

      try {
        // Fetch employee details
        const employeeDetails = await fetchEmplyeeDetails(userId);
        if (employeeDetails && employeeDetails.length > 0) {
          setEmployeeData(employeeDetails[0]);
          // Fetch today's analytics by default
          await fetchAnalytics(userId);
        }
      } catch (error) {
        console.error("Error fetching initial data:", error);
      } finally {
        setInitialLoading(false);
      }
    };

    fetchInitialData();
  }, [userId]);

  // Fetch analytics data
  const fetchAnalytics = async (employeeId) => {
    setLoading(true);
    try {
      let data;
      if (viewType === 'today') {
        data = await fetchTodayEmployeeStats(employeeId);
      } else {
        data = await fetchDateRangeEmployeeStats(employeeId, startDate, endDate);
      }
      setAnalyticsData(data);
    } catch (error) {
      console.error("Error fetching analytics:", error);
    } finally {
      setLoading(false);
    }
  };

  // Handle date range change
  const handleDateRangeSubmit = () => {
    if (userId) {
      fetchAnalytics(userId);
    }
  };

  // Handle view type change
  const handleViewTypeChange = (newViewType) => {
    setViewType(newViewType);
    if (userId) {
      if (newViewType === 'today') {
        fetchAnalytics(userId);
      }
    }
  };

  const getStatusColor = (status, value) => {
    if (status.includes('answered') || status.includes('interested') || status.includes('converted')) {
      return value > 0 ? 'primary' : 'default';
    } else if (status.includes('callback') || status.includes('follow')) {
      return value > 0 ? 'secondary' : 'default';
    } else {
      return 'default';
    }
  };

  const getChipColor = (status) => {
    const statusLower = status.toLowerCase();
    if (statusLower.includes('answered') || statusLower.includes('interested') || statusLower.includes('converted')) {
      return { backgroundColor: '#4caf50', color: 'white' };
    } else if (statusLower.includes('callback') || statusLower.includes('follow')) {
      return { backgroundColor: '#ff9800', color: 'white' };
    } else {
      return { backgroundColor: '#f44336', color: 'white' };
    }
  };

  // Calculate derived metrics
  const getCalledLeads = () => {
    if (!analyticsData) return 0;
    return analyticsData.totalAssignedLeads - analyticsData.neverCalledLeads;
  };

  const getCallPenetrationRate = () => {
    if (!analyticsData || analyticsData.totalAssignedLeads === 0) return 0;
    return ((analyticsData.totalAssignedLeads - analyticsData.neverCalledLeads) / analyticsData.totalAssignedLeads) * 100;
  };

  if (initialLoading) {
    return (
      <Container maxWidth="xl" className={classes.root}>
        <div className={classes.loadingContainer}>
          <CircularProgress size={60} color="primary" />
        </div>
      </Container>
    );
  }

  if (!userId || !employeeData) {
    return (
      <Container maxWidth="xl" className={classes.root}>
        <Paper className={classes.emptyState} elevation={0}>
          <Person className={classes.emptyStateIcon} />
          <Typography variant="h6" color="textSecondary" gutterBottom>
            Unable to Load Dashboard
          </Typography>
          <Typography variant="body2" color="textSecondary">
            Please login again to access your dashboard
          </Typography>
        </Paper>
      </Container>
    );
  }

  return (
    <Container maxWidth="xl" className={classes.root}>
      {/* Welcome Section */}
      <Paper className={classes.welcomeCard} elevation={0}>
        <div className={classes.employeeInfo}>
          <Avatar className={classes.employeeAvatar}>
            <AccountCircle style={{ fontSize: '3rem' }} />
          </Avatar>
          <div className={classes.employeeDetails}>
            <Typography className={classes.welcomeText}>
              Welcome back,
            </Typography>
            <Typography className={classes.employeeName}>
              {employeeData.firstName} {employeeData.lastName}
            </Typography>
            <Typography className={classes.employeeContact}>
              <Email className={classes.contactIcon} />
              {employeeData.email}
            </Typography>
            <Typography className={classes.employeeContact}>
              <Phone className={classes.contactIcon} />
              {employeeData.mobileNumber}
            </Typography>
            <Typography className={classes.employeeContact}>
              <SupervisorAccount className={classes.contactIcon} />
              Manager: {employeeData.managerName || 'Not Assigned'}
            </Typography>
            <div className={classes.onlineStatus}>
              <div className={classes.statusDot}></div>
              <Typography style={{ color: 'rgba(255,255,255,0.9)' }}>
                Online
              </Typography>
            </div>

            {/* Quick Performance Overview in Welcome Card */}
            {analyticsData && (
              <div className={classes.performanceCard}>
                <Typography className={classes.performanceTitle}>
                  Today's Quick Stats
                </Typography>
                <div className={classes.performanceGrid}>
                  <div className={classes.performanceItem}>
                    <div className={classes.performanceValue}>
                      {analyticsData.totalCallsMade}
                    </div>
                    <div className={classes.performanceLabel}>
                      Calls Made
                    </div>
                  </div>
                  <div className={classes.performanceItem}>
                    <div className={classes.performanceValue}>
                      {analyticsData.answeredCalls}
                    </div>
                    <div className={classes.performanceLabel}>
                      Answered
                    </div>
                  </div>
                  <div className={classes.performanceItem}>
                    <div className={classes.performanceValue}>
                      {analyticsData.interestedLeads}
                    </div>
                    <div className={classes.performanceLabel}>
                      Interested
                    </div>
                  </div>
                  <div className={classes.performanceItem}>
                    <div className={classes.performanceValue}>
                      {analyticsData.convertedLeads}
                    </div>
                    <div className={classes.performanceLabel}>
                      Converted
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </Paper>

      {/* Filter Section */}
      <Paper className={classes.filterCard} elevation={0}>
        <Typography className={classes.sectionTitle}>
          <Assessment className={classes.sectionIcon} />
          My Performance Analytics
        </Typography>

        <Grid container spacing={3} className={classes.filterGrid} alignItems="flex-end">
          <Grid item xs={12} md={3}>
            <FormControl className={classes.formControl} variant="outlined">
              <InputLabel>View Type</InputLabel>
              <Select
                value={viewType}
                onChange={(e) => handleViewTypeChange(e.target.value)}
                label="View Type"
              >
                <MenuItem value="today">Today</MenuItem>
                <MenuItem value="dateRange">Date Range</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          {viewType === 'dateRange' && (
            <>
              <Grid item xs={12} md={3}>
                <TextField
                  fullWidth
                  type="date"
                  label="Start Date"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  fullWidth
                  type="date"
                  label="End Date"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  onClick={handleDateRangeSubmit}
                  startIcon={<Refresh />}
                  className={classes.applyButton}
                  size="large"
                >
                  Apply
                </Button>
              </Grid>
            </>
          )}
        </Grid>
      </Paper>

      {/* Loading State */}
      {loading && (
        <div className={classes.loadingContainer}>
          <CircularProgress size={60} color="primary" />
        </div>
      )}

      {/* Analytics Data */}
      {analyticsData && !loading && (
        <>
          {/* Lead Assignment Overview */}
          <Grid container spacing={3} className={classes.leadAssignmentGrid}>
            <Grid item xs={12} sm={6} md={3}>
              <Card className={classes.leadAssignmentCard} elevation={0}>
                <div className={classes.statContent}>
                  <Assignment className={classes.statIcon} style={{ color: '#2196f3' }} />
                  <Typography className={classes.statValue} style={{ color: '#2196f3' }}>
                    {analyticsData.totalAssignedLeads}
                  </Typography>
                  <Typography className={classes.statLabel}>
                    Total Assigned Leads
                  </Typography>
                </div>
              </Card>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <Card className={classes.leadAssignmentCard} elevation={0}>
                <div className={classes.statContent}>
                  <PhoneDisabled className={classes.statIcon} style={{ color: '#ff5722' }} />
                  <Typography className={classes.statValue} style={{ color: '#ff5722' }}>
                    {analyticsData.neverCalledLeads}
                  </Typography>
                  <Typography className={classes.statLabel}>
                    Never Called Leads
                  </Typography>
                </div>
              </Card>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <Card className={classes.leadAssignmentCard} elevation={0}>
                <div className={classes.statContent}>
                  <Phone className={classes.statIcon} style={{ color: '#4caf50' }} />
                  <Typography className={classes.statValue} style={{ color: '#4caf50' }}>
                    {getCalledLeads()}
                  </Typography>
                  <Typography className={classes.statLabel}>
                    Called Leads
                  </Typography>
                </div>
              </Card>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <Card className={classes.leadAssignmentCard} elevation={0}>
                <div className={classes.statContent}>
                  <TrendingUp className={classes.statIcon} style={{ color: '#9c27b0' }} />
                  <Typography className={classes.statValue} style={{ color: '#9c27b0' }}>
                    {getCallPenetrationRate().toFixed(1)}%
                  </Typography>
                  <Typography className={classes.statLabel}>
                    Call Penetration Rate
                  </Typography>
                  <Chip
                    label={`${getCalledLeads()}/${analyticsData.totalAssignedLeads}`}
                    className={classes.percentageChip}
                    style={{ backgroundColor: '#9c27b0', color: 'white' }}
                    size="small"
                  />
                </div>
              </Card>
            </Grid>
          </Grid>

          {/* Main Stats Cards */}
          <Grid container spacing={3} style={{ marginTop: 0 }}>
            <Grid item xs={12} sm={6} md={3}>
              <Card className={classes.statCard} elevation={0}>
                <div className={classes.statContent}>
                  <Phone className={classes.statIcon} color="primary" />
                  <Typography className={classes.statValue} color="primary">
                    {analyticsData.totalCallsMade}
                  </Typography>
                  <Typography className={classes.statLabel}>
                    Total Calls Made
                  </Typography>
                </div>
              </Card>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <Card className={classes.statCard} elevation={0}>
                <div className={classes.statContent}>
                  <CheckCircle className={classes.statIcon} style={{ color: '#4caf50' }} />
                  <Typography className={classes.statValue} style={{ color: '#4caf50' }}>
                    {analyticsData.answeredCalls}
                  </Typography>
                  <Typography className={classes.statLabel}>
                    Answered Calls
                  </Typography>
                  <Chip
                    label={`${analyticsData.answerRate.toFixed(1)}%`}
                    className={classes.percentageChip}
                    style={{ backgroundColor: '#4caf50', color: 'white' }}
                    size="small"
                  />
                </div>
              </Card>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <Card className={classes.statCard} elevation={0}>
                <div className={classes.statContent}>
                  <TrendingUp className={classes.statIcon} style={{ color: '#ff9800' }} />
                  <Typography className={classes.statValue} style={{ color: '#ff9800' }}>
                    {analyticsData.interestedLeads}
                  </Typography>
                  <Typography className={classes.statLabel}>
                    Interested Leads
                  </Typography>
                  <Chip
                    label={`${analyticsData.interestRate.toFixed(1)}%`}
                    className={classes.percentageChip}
                    style={{ backgroundColor: '#ff9800', color: 'white' }}
                    size="small"
                  />
                </div>
              </Card>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <Card className={classes.statCard} elevation={0}>
                <div className={classes.statContent}>
                  <Visibility className={classes.statIcon} style={{ color: '#2196f3' }} />
                  <Typography className={classes.statValue} style={{ color: '#2196f3' }}>
                    {analyticsData.convertedLeads}
                  </Typography>
                  <Typography className={classes.statLabel}>
                    Converted Leads
                  </Typography>
                  <Chip
                    label={`${analyticsData.conversionRate.toFixed(1)}%`}
                    className={classes.percentageChip}
                    style={{ backgroundColor: '#2196f3', color: 'white' }}
                    size="small"
                  />
                </div>
              </Card>
            </Grid>
          </Grid>

          {/* Detailed Breakdown */}
          <Grid container spacing={3} style={{ marginTop: 0 }}>
            {/* Call Status Breakdown */}
            <Grid item xs={12} md={6}>
              <Card className={classes.breakdownCard} elevation={0}>
                <CardHeader
                  className={classes.breakdownHeader}
                  title={
                    <Typography className={classes.sectionTitle}>
                      Call Status Breakdown
                    </Typography>
                  }
                  subheader={`Period: ${viewType === 'today' ? 'Today' : `${startDate} to ${endDate}`}`}
                />
                <div className={classes.breakdownContent}>
                  {Object.entries(analyticsData.callStatusBreakdown).map(([status, count]) => (
                    <div key={status} className={classes.breakdownItem}>
                      <Typography className={classes.breakdownLabel}>
                        {status.replace(/_/g, ' ').toLowerCase().replace(/\b\w/g, l => l.toUpperCase())}
                      </Typography>
                      <Chip
                        label={count}
                        style={getChipColor(status)}
                        size="small"
                      />
                    </div>
                  ))}
                </div>
              </Card>
            </Grid>

            {/* Lead Status Breakdown */}
            <Grid item xs={12} md={6}>
              <Card className={classes.breakdownCard} elevation={0}>
                <CardHeader
                  className={classes.breakdownHeader}
                  title={
                    <Typography className={classes.sectionTitle}>
                      Lead Status Breakdown
                    </Typography>
                  }
                  subheader="Lead quality and conversion tracking"
                />
                <div className={classes.breakdownContent}>
                  {Object.entries(analyticsData.leadStatusBreakdown).map(([status, count]) => (
                    <div key={status} className={classes.breakdownItem}>
                      <Typography className={classes.breakdownLabel}>
                        {status.replace(/_/g, ' ').toLowerCase().replace(/\b\w/g, l => l.toUpperCase())}
                      </Typography>
                      <Chip
                        label={count}
                        style={getChipColor(status)}
                        size="small"
                      />
                    </div>
                  ))}
                </div>
              </Card>
            </Grid>
          </Grid>

          {/* Additional Stats */}
          <Grid container spacing={3} className={classes.additionalStatsGrid}>
            <Grid item xs={12} sm={6} md={2}>
              <Card className={classes.additionalStatCard} elevation={0}>
                <div className={classes.additionalStatContent}>
                  <PhoneMissed className={classes.additionalStatIcon} style={{ color: '#f44336' }} />
                  <Typography className={classes.additionalStatValue} style={{ color: '#f44336' }}>
                    {analyticsData.notAnsweredCalls}
                  </Typography>
                  <Typography className={classes.additionalStatLabel}>
                    Not Answered
                  </Typography>
                </div>
              </Card>
            </Grid>

            <Grid item xs={12} sm={6} md={2}>
              <Card className={classes.additionalStatCard} elevation={0}>
                <div className={classes.additionalStatContent}>
                  <PhoneCallback className={classes.additionalStatIcon} style={{ color: '#ff9800' }} />
                  <Typography className={classes.additionalStatValue} style={{ color: '#ff9800' }}>
                    {analyticsData.callbackRequests}
                  </Typography>
                  <Typography className={classes.additionalStatLabel}>
                    Callbacks
                  </Typography>
                </div>
              </Card>
            </Grid>

            <Grid item xs={12} sm={6} md={2}>
              <Card className={classes.additionalStatCard} elevation={0}>
                <div className={classes.additionalStatContent}>
                  <Schedule className={classes.additionalStatIcon} style={{ color: '#9c27b0' }} />
                  <Typography className={classes.additionalStatValue} style={{ color: '#9c27b0' }}>
                    {analyticsData.followUpNeededLeads}
                  </Typography>
                  <Typography className={classes.additionalStatLabel}>
                    Follow-ups
                  </Typography>
                </div>
              </Card>
            </Grid>

            <Grid item xs={12} sm={6} md={2}>
              <Card className={classes.additionalStatCard} elevation={0}>
                <div className={classes.additionalStatContent}>
                  <TrendingUp className={classes.additionalStatIcon} style={{ color: '#f44336' }} />
                  <Typography className={classes.additionalStatValue} style={{ color: '#f44336' }}>
                    {analyticsData.hotLeads}
                  </Typography>
                  <Typography className={classes.additionalStatLabel}>
                    Hot Leads
                  </Typography>
                </div>
              </Card>
            </Grid>

            <Grid item xs={12} sm={6} md={2}>
              <Card className={classes.additionalStatCard} elevation={0}>
                <div className={classes.additionalStatContent}>
                  <TrendingUp className={classes.additionalStatIcon} style={{ color: '#2196f3' }} />
                  <Typography className={classes.additionalStatValue} style={{ color: '#2196f3' }}>
                    {analyticsData.coldLeads}
                  </Typography>
                  <Typography className={classes.additionalStatLabel}>
                    Cold Leads
                  </Typography>
                </div>
              </Card>
            </Grid>

            <Grid item xs={12} sm={6} md={2}>
              <Card className={classes.additionalStatCard} elevation={0}>
                <div className={classes.additionalStatContent}>
                  <Cancel className={classes.additionalStatIcon} style={{ color: '#607d8b' }} />
                  <Typography className={classes.additionalStatValue} style={{ color: '#607d8b' }}>
                    {analyticsData.lostLeads}
                  </Typography>
                  <Typography className={classes.additionalStatLabel}>
                    Lost Leads
                  </Typography>
                </div>
              </Card>
            </Grid>
          </Grid>
        </>
      )}

      {/* No Data State */}
      {!analyticsData && !loading && userId && (
        <Paper className={classes.emptyState} elevation={0}>
          <Assessment className={classes.emptyStateIcon} />
          <Typography variant="h6" color="textSecondary" gutterBottom>
            No data available for the selected period
          </Typography>
          <Typography variant="body2" color="textSecondary">
            Try selecting a different date range or check back later
          </Typography>
        </Paper>
      )}
    </Container>
  );
}